import React from 'react';
import { Mail, Phone, MapPin, Facebook, Instagram, Linkedin } from 'lucide-react';
import { CmsLink as Link, EditableText } from '../content/EditableText';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* About */}
          <div>
            <h3 className="text-white text-lg font-semibold mb-4"><EditableText contentKey="shared.footer.brandName" multiline={false} /></h3>
            <p className="text-sm mb-4">
              <EditableText contentKey="shared.footer.about" />
            </p>
            <div className="flex space-x-4">
              <a href="#" className="hover:text-brand-400 transition-colors">
                <Facebook className="h-5 w-5" />
              </a>
              <a href="#" className="hover:text-brand-400 transition-colors">
                <Instagram className="h-5 w-5" />
              </a>
              <a href="#" className="hover:text-brand-400 transition-colors">
                <Linkedin className="h-5 w-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white text-lg font-semibold mb-4"><EditableText contentKey="shared.footer.quickLinks" multiline={false} /></h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/" className="hover:text-brand-400 transition-colors">
                  <EditableText contentKey="shared.nav.home" multiline={false} />
                </Link>
              </li>
              <li>
                <Link to="/therapists" className="hover:text-brand-400 transition-colors">
                  <EditableText contentKey="shared.nav.therapists" multiline={false} />
                </Link>
              </li>
              <li>
                <Link to="/blog" className="hover:text-brand-400 transition-colors">
                  <EditableText contentKey="shared.nav.blog" multiline={false} />
                </Link>
              </li>
              <li>
                <Link to="/insurance" className="hover:text-brand-400 transition-colors">
                  <EditableText contentKey="shared.nav.insurance" multiline={false} />
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-white text-lg font-semibold mb-4"><EditableText contentKey="shared.footer.services" multiline={false} /></h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/services/individual-therapy" className="hover:text-brand-400 transition-colors">
                  <EditableText contentKey="shared.nav.individualTherapy" multiline={false} />
                </Link>
              </li>
              <li>
                <Link to="/services/couples-counseling" className="hover:text-brand-400 transition-colors">
                  <EditableText contentKey="shared.nav.couplesCounseling" multiline={false} />
                </Link>
              </li>
              <li>
                <Link to="/services/family-therapy" className="hover:text-brand-400 transition-colors">
                  <EditableText contentKey="shared.nav.familyTherapy" multiline={false} />
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-white text-lg font-semibold mb-4"><EditableText contentKey="shared.footer.contactUs" multiline={false} /></h3>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start">
                <MapPin className="h-5 w-5 mr-2 mt-0.5 flex-shrink-0" />
                <EditableText contentKey="shared.footer.address" />
              </li>
              <li className="flex items-center">
                <Phone className="h-5 w-5 mr-2 flex-shrink-0" />
                <EditableText contentKey="shared.footer.phone" multiline={false} />
              </li>
              <li className="flex items-center">
                <Mail className="h-5 w-5 mr-2 flex-shrink-0" />
                <EditableText contentKey="shared.footer.email" multiline={false} />
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 text-center text-sm">
          <p>&copy; {new Date().getFullYear()} <EditableText contentKey="shared.footer.copyright" multiline={false} /></p>
          <div className="mt-2 space-x-4">
            <Link to="/privacy" className="hover:text-brand-400 transition-colors">
              <EditableText contentKey="shared.footer.privacy" multiline={false} />
            </Link>
            <Link to="/terms" className="hover:text-brand-400 transition-colors">
              <EditableText contentKey="shared.footer.terms" multiline={false} />
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
